import { Dispatch, GetState } from "common/types";

import { getSectionParentId } from "seneca-common/features/course/state";

import { expandSections } from "../state";

export function expandAllParentsForLeafSection(
  courseId: string,
  leafSectionId: string
) {
  return function (dispatch: Dispatch, getState: GetState) {
    const state = getState();

    let sectionIds: string[] = [];
    let parentId = getSectionParentId(state, leafSectionId);

    while (parentId && parentId !== courseId) {
      sectionIds = [...sectionIds, parentId];
      parentId = getSectionParentId(state, parentId);
    }

    dispatch(expandSections(sectionIds));
  };
}
